import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
export function render(_ctx, _cache) {
  const _component_MHeader = _resolveComponent("MHeader");
  const _component_router_view = _resolveComponent("router-view");
  const _component_MFooter = _resolveComponent("MFooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_MHeader), _createVNode(_component_router_view), _createVNode(_component_MFooter)]);
}